import React, { useState } from 'react'
import Loading from "../../components/ui/loading";
import { TextInput } from '../../components/form/Input';
import Alert, { AlertPropsType } from '../../components/ui/alert';
import { CreateDailyDeliveryReportErrors, fetchCreateDeliveryReport, fetchCreateDeliveryReportPayload } from './ShippingServices';
import SelectInput from '../../components/form/SelectInput';
import { DatePicker } from '../../components/form/DatePicker';
import { Button } from '../../components/ui/button';
import { IoSave } from 'react-icons/io5';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';

type SelectState = {
  value: string;
  label: string;
};

const CITY_OPTIONS: SelectState[] = [
  { value: "all", label: "Pilih Kota" },
  { value: "01", label: "Medan" },
  { value: "11", label: "Kerinci" }
];

const DailyDeliveryReportForm = () => {
  const { user } = useSelector((state: RootState) => state.auth);

  // const [deliveryNumber, setDeliveryNumber] = useState<string>("");
  const [platNumber, setPlatNumber] = useState<string>("");
  const [driverName, setDriverName] = useState<string>("");
  const [selectedOriginCity, setSelectedOriginCity] = useState<SelectState>({ value: "all", label: "Pilih Kota" });
  const [selectedDestinationCity, setSelectedDestinationCity] = useState<SelectState>({ value: "all", label: "Pilih Kota" });
  // const [departureTime, setDepartureTime] = useState<string>("");
  const [selectedShippingDate, setSelectedShippingDate] = useState<Date | undefined>(new Date());
  const [selectedArrivalDate, setSelectedArrivalDate] = useState<Date | undefined>(new Date(new Date().setDate(new Date().getDate() + 1)));

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [alert, setAlert] = useState<AlertPropsType | null>(null);
  const [errors, setErrors] = useState<CreateDailyDeliveryReportErrors | null>(null);

  const deleteErrorHandler = (event: React.ChangeEvent<HTMLInputElement> | string) => {
    if (errors) {
      const newErrors = errors;
      const removedProperty = typeof event === "string" ? event : event.target.name;
      delete newErrors[removedProperty];
      setErrors(newErrors);
    };
  };

  const resetFormValues = () => {
    setPlatNumber("")
    setDriverName("")
    setSelectedOriginCity({ value: "all", label: "Pilih Kota" })
    setSelectedDestinationCity({ value: "all", label: "Pilih Kota" })
    setSelectedShippingDate(new Date());
    setSelectedArrivalDate(new Date(new Date().setDate(new Date().getDate() + 1)))
  };

  const submitHandler = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // Validate form fields
    const newErrors: CreateDailyDeliveryReportErrors = {
      platNumber: platNumber ? "" : "No. Polisi harus diisi",
      driverName: driverName ? "" : "Nama Supir harus diisi",
      selectedOriginCity: selectedOriginCity.value !== "all" ? "" : "Kota Asal harus dipilih",
      selectedDestinationCity: selectedDestinationCity.value === "all" ? "Kota Tujuan harus dipilih" : selectedDestinationCity.value === selectedOriginCity.value ? "Kota Tujuan tidak boleh sama" : "",
      selectedShippingDate: selectedShippingDate ? "" : "Tanggal Pengiriman harus dipilih",
      selectedArrivalDate: selectedArrivalDate ? "" : "Tanggal Tiba harus dipilih"
    };

    // Filter out empty error messages
    const filteredErrors = Object.fromEntries(Object.entries(newErrors).filter(([_, value]) => value !== ""));
    if (Object.keys(filteredErrors).length > 0) {
      setErrors(filteredErrors as CreateDailyDeliveryReportErrors);
      return;
    }

    // If no errors, proceed with form submission logic
    const payload: fetchCreateDeliveryReportPayload = {
      vehicle_plate_number: platNumber,
      driver_name: driverName,
      origin_city: selectedOriginCity.value,
      destination_city: selectedDestinationCity.value,
      // departure_time: departureTime,
      departure_date: moment(selectedShippingDate).format("DD/MM/YYYY"),
      estimation_arrival_date: moment(selectedArrivalDate).format("DD/MM/YYYY"),
      arrival_date: moment(selectedArrivalDate).format("DD/MM/YYYY"),
      shipping_ids: [],
      admin_maker: user?._id,
    };

    const successRequest = await fetchCreateDeliveryReport(payload);
    if (!successRequest) {
      setIsLoading(false);
      setAlert({
        variant: "error",
        message: "Terjadi kesalahan pada server. Mohon coba beberapa saat lagi!"
      });
      return;
    }

    const { status, message } = successRequest;

    if (status === 200) {
      resetFormValues();
      setIsLoading(false);
      setAlert({
        variant: "success",
        message: "Data berhasil tersimpan."
      });
    } else {
      setIsLoading(false);
      setAlert({
        variant: "error",
        message
      });
    };
  }

  return (
    <form onSubmit={submitHandler} className='p-4'>
      <div className='grid lg:grid-cols-2 gap-8'>
        <div>
          {/* <div className='flex flex-col gap-1.5'>
            <label className='font-semibold'>No. Pengiriman</label>
            <TextInput
              required
              name="deliveryNumber"
              value={deliveryNumber}
              placeholder="No. Pengiriman"
              disabled={isLoading}
              error={errors?.deliveryNumber}
              onChange={(e: any) => {
                deleteErrorHandler(e.target.name);
                setDeliveryNumber(e.target.value)
              }}
            />
          </div> */}
          <div className="grid grid-cols-2 gap-2.5 mt-2">
            <div className='flex flex-col gap-1.5 max-h-10'>
              <label className="font-semibold">Kota Asal</label>
              <SelectInput
                name="origin_city"
                defaultValue={selectedOriginCity.value}
                value={selectedOriginCity.value}
                placeholder="Pilih kota"
                options={CITY_OPTIONS}
                inputClassName=""
                disabled={isLoading}
                onChange={(value) => {
                  const selectedCity = CITY_OPTIONS.find(el => el.value === value);
                  if (selectedCity) setSelectedOriginCity(selectedCity);
                }}
                error={errors?.selectedOriginCity}
              />
            </div>
            <div className='flex flex-col gap-1.5'>
              <label className="font-semibold">Kota Tujuan</label>
              <SelectInput
                name="destination_city"
                defaultValue={selectedDestinationCity.value}
                value={selectedDestinationCity.value}
                placeholder="Pilih kota"
                options={CITY_OPTIONS}
                inputClassName=""
                disabled={isLoading}
                onChange={(value) => {
                  const selectedCity = CITY_OPTIONS.find(el => el.value === value);
                  if (selectedCity) setSelectedDestinationCity(selectedCity);
                }}
                error={errors?.selectedDestinationCity}
              />
            </div>
            <div className='flex flex-col gap-1.5'>
              <label className='font-semibold'>No. Polisi</label>
              <TextInput
                required
                name="platNumber"
                value={platNumber}
                placeholder="No. Polisi"
                disabled={isLoading}
                error={errors?.platNumber}
                onChange={(e: any) => {
                  deleteErrorHandler(e.target.name);
                  setPlatNumber(e.target.value)
                }}
              />
            </div>
            <div className='flex flex-col gap-1.5'>
              <label className='font-semibold'>Nama Supir</label>
              <TextInput
                required
                name="driverName"
                value={driverName}
                placeholder="Nama Supir"
                disabled={isLoading}
                error={errors?.driverName}
                onChange={(e: any) => {
                  deleteErrorHandler(e.target.name);
                  setDriverName(e.target.value)
                }}
              />
            </div>
          </div>
        </div>
        <div>
          <div className='flex flex-col gap-1.5 mt-1.5'>
            <label className="font-semibold">Tanggal Pengiriman</label>
            <DatePicker
              mode="single"
              value={selectedShippingDate}
              disabled={isLoading}
              onChange={(value) => {
                const selectedDate = value as Date;
                setSelectedShippingDate(selectedDate);
                const nextDay = new Date(selectedDate);
                nextDay.setDate(nextDay.getDate() + 1);
                setSelectedArrivalDate(nextDay); // Automatically set arrival date to the next day
              }}
            />
          </div>
          {/* <div className='flex flex-col gap-1.5 mt-2'>
            <label className='font-semibold'>Jam Berangkat</label>
            <input
              type="text"
              id="departureTime"
              value={departureTime}
              disabled
              aria-label="Jam Berangkat"
              className={`tracking-tight py-2 px-2.5 flex-1 rounded-lg text-sm bg-white border disabled:bg-neutral-300 disabled:text-neutral-700 focus:outline-0 focus-visible:outline-none w-full ${errors?.departureTime ? "border-red-600 !text-red-600" : "text-black"}`}
            />
          </div> */}
          <div className='flex flex-col gap-1.5 mt-2'>
            <label className="font-semibold">Tanggal Tiba</label>
            <DatePicker
              mode="single"
              value={selectedArrivalDate}
              disabled={isLoading}
              onChange={(value) => setSelectedArrivalDate(value as Date)}
            />
          </div>
        </div>
        {alert &&
          <div className='col-span-2'>
            {<Alert options={alert} />}
          </div>
        }
        <div className='col-span-2 flex justify-end'>
          {isLoading ?
            <div className='py-1'>
              <Loading show={isLoading} size='small' labelClassName='text-main-blue text-sm' spinnerClassName='text-main-blue text-sm' />
            </div>
            :
            <Button
              disabled={isLoading}
              type='submit'
              className="bg-secondary-blue hover:!bg-sky-400 transition-all ease-in-out duration-300 text-white py-[10px] w-36 rounded-xl font-bold flex items-center gap-1.5 text-sm uppercase"
            >
              <>
                <IoSave size={10} />
                Simpan
              </>
            </Button>
          }
        </div>
      </div>
    </form>
  )
}

export default DailyDeliveryReportForm